import { Flex, Button, Icon } from '@chakra-ui/react';
import React from 'react';
import { Navigate, Link as RouterLink, useParams } from 'react-router-dom';
import { z } from 'zod';

import { FiTool } from 'react-icons/fi';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { ImplementationDetails } from '~/packages/implementations/ui/ImplementationDetails';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const params = useParams();
  const { implementationId } = RouteParamsStruct.parse(params);

  return (
    <ImplementationDetails
      organizationId={user.organization.id}
      implementationId={implementationId}
      implementationRoutePrefix="/implementations/"
      renderActionButtons={() => (
        <>
          <Button
            as={RouterLink}
            to={`/implementations/${implementationId}/tape-builder`}
            variant="outline"
          >
            Open Tape Builder <Icon marginLeft="50px" as={FiTool} />
          </Button>
        </>
      )}
    />
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/" />;
    }}
  >
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <RouteBase />
    </Flex>
  </RouteErrorBoundary>
);
